const strings = {
  title: 'Interação Fonte Auxiliar',
}

export default strings
